import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    content: "AirPortals has been a game-changer for our business. Since listing our services, we've connected with clients we never would have reached otherwise.",
    author: "Rachel T",
    role: "FBO Manager"
  },
  {
    id: 2,
    content: "We love how easy it was to set up our listing and showcase the airports we serve. The platform's visibility has significantly boosted our bookings.",
    author: "Caleb S",
    role: "CEO"
  },
  {
    id: 3,
    content: "As a small aviation service provider, having a presence on AirPortals has been invaluable. The detailed listing options really helped us stand out.",
    author: "Daniel V",
    role: "Charter Broker"
  }
];

export function Testimonials() {
  return (
    <div className="py-8 sm:py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8 lg:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            Trusted by Aviation Professionals
          </h2>
          <p className="text-sm sm:text-base text-gray-600">
            Join thousands of service providers growing their business with AirPortals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 relative"
            >
              <Quote className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 text-primary-200 absolute top-3 right-3 sm:top-4 sm:right-4 lg:top-6 lg:right-6" />
              
              <div className="flex items-center gap-1 mb-3 sm:mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>
              
              <blockquote className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base leading-relaxed">
                "{testimonial.content}"
              </blockquote>
              
              <div>
                <div className="font-medium text-gray-900 text-sm sm:text-base">
                  {testimonial.author}
                </div>
                <div className="text-xs sm:text-sm text-gray-500">
                  {testimonial.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}